'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var AuthProvider = require('./components/AuthProvider.js');
var TiaAuthClient = require('./utils/TiaAuthClient.js');
var oidcClient = require('oidc-client');



exports.AuthProvider = AuthProvider.AuthProvider;
exports.TiaAuthContext = AuthProvider.TiaAuthContext;
exports.useTiaAuth = AuthProvider.useTiaAuth;
exports.TiaAuthClient = TiaAuthClient.TiaAuthClient;
Object.defineProperty(exports, 'User', {
	enumerable: true,
	get: function () {
		return oidcClient.User;
	}
});
